// D24: credit issue and expiry dates, "expiring within N days" windows and the reminder run all follow Pacific time.
export const BUSINESS_TIME_ZONE = 'America/Los_Angeles';
//# sourceMappingURL=constants.js.map